import React from 'react';
import * as S from './styled';
export const StepProgressBar = ({ step, totalSteps, appearance = 'success' }) => {
    const currentValue = Math.max(0, Math.min(totalSteps, step));
    const rectangleWidth = `${Math.ceil(100 / totalSteps)}%`;
    const squares = Array.from({ length: totalSteps }, (_, index) => (React.createElement(S.Rectangle, { key: index, "$isActive": index < currentValue, "$rectangleWidth": rectangleWidth, "$appearance": appearance })));
    return React.createElement(S.Container, null, squares);
};
//# sourceMappingURL=StepProgressBar.js.map